import Chip from "@mui/material/Chip";
const certaintyChips  = [
  <Chip label="not found" size="small" color="error" />,
  <Chip label="very strong" size="small" color="success" />,
  <Chip label="strong" size="small" color="success" />,
  <Chip label="weak" size="small" color="warning" />,
];

export default certaintyChips;
